import { render, staticRenderFns } from "./crudContract.vue?vue&type=template&id=3c48c922"
import script from "./crudContract.vue?vue&type=script&lang=js"
export * from "./crudContract.vue?vue&type=script&lang=js"
import style0 from "./crudContract.vue?vue&type=style&index=0&id=3c48c922&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports